import { render, staticRenderFns } from "./TinymceEditor.vue?vue&type=template&id=2a85d3ab"
import script from "./TinymceEditor.vue?vue&type=script&lang=js"
export * from "./TinymceEditor.vue?vue&type=script&lang=js"
import style0 from "./TinymceEditor.vue?vue&type=style&index=0&id=2a85d3ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports